import React, { Component, createRef } from 'react'
import { Paper } from '@material-ui/core'
import jsSHA from 'jssha'

class SisenseDashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      embedLink: this.props.embedLink,
      intervalId: 0,
    }
    this.iframe = createRef()
  }

  componentDidMount() {
    const { refreshTriggerInterval } = this.props

    window.addEventListener('message', this.receiveMessage, false)

    if (refreshTriggerInterval && this.iframe.current.contentWindow) {
      const id = setInterval(() => {
        this.iframe.current.contentWindow.postMessage(
          { event_type: 'refresh_charts' },
          '*',
        )
      }, refreshTriggerInterval * 1000)

      this.setState({ intervalId: id })
    }
  }

  componentWillUnmount() {
    const { intervalId } = this.state

    window.removeEventListener('message', this.receiveMessage, false)

    if (intervalId) {
      clearInterval(intervalId)
    }
  }

  componentDidUpdate(prevProps) {
    const { embedLink } = this.props

    if (
      embedLink !== prevProps.embedLink &&
      this.state.embedLink !== embedLink
    ) {
      this.setState({ embedLink })
    }
  }

  periscopeUrl = (apiKey, data) => {
    // Set the path and escape the querystring
    const escapedQS = escape(JSON.stringify(data))
    const path = `/api/embedded_dashboard?data=${escapedQS}`

    // Use SHA to generate signature with API key
    const sha = new jsSHA('SHA-256', 'TEXT', {
      hmacKey: { value: apiKey, format: 'TEXT' },
    })
    sha.update(path)
    const signature = sha.getHash('HEX')

    // Build and return final URL
    return `https://app.periscopedata.com${path}&signature=${signature}`
  }

  // Drilldown listener
  receiveMessage = event => {
    if (
      typeof event.data === 'object' &&
      event.data.event_type === 'drilldown'
    ) {
      const data = {
        dashboard: event.data.destination_dashboard_id,
        embed: 'v2',
        filters: this.filterValues(event.data.filter_values),
      }

      this.setState({
        embedLink: this.periscopeUrl(
          window._env.REACT_APP_SISENSE_API_KEY,
          data,
        ),
      })
    }
  }

  // Parse drilldown filter values and create new filter array
  filterValues = values => {
    const output = []

    values.forEach(obj => {
      output.push({ name: obj.filter_name, value: obj.column_value })
    })

    return output
  }

  render() {
    return (
      <Paper className="projection">
        <iframe
          title="sisense"
          id="sisense"
          ref={this.iframe}
          src={this.state.embedLink}
        />
      </Paper>
    )
  }
}

export default SisenseDashboard
